import Actions from "../Types";

const initialState = {
  isGettingDemoSlots: false,
  getDemoSlotsSuccess: false,
  isGettingMonthsSlots: false,
  getDemoMonthsSuccess: false,
  demoMonths: [],
  isGettingDemoDays: false,
  getDemoSlotsDays: false,
  demoDays: [],
  isBookingSlot: false,
  bookingSlotSuccess: false,
  DemoSlots: [],
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Actions.GET_DEMO_SLOT_START:
      return {
        ...state,
        isGettingDemoSlots: true,
        getDemoSlotsSuccess: false,
        error: null,
      };
    case Actions.GET_DEMO_SLOT_SUCCESS:
      return {
        ...state,
        isGettingDemoSlots: false,
        getDemoSlotsSuccess: true,
        DemoSlots: action.payload,
        error: null,
      };
    case Actions.GET_DEMO_SLOT_FAILURE:
      return {
        ...state,
        isGettingDemoSlots: false,
        getDemoSlotsSuccess: false,
        error: action.payload,
      };
    case Actions.GET_DEMO_MONTHS_START:
      return {
        ...state,
        isGettingDemoMonths: true,
        getDemoMonthsSuccess: false,
        error: null,
      };
    case Actions.GET_DEMO_MONTHS_SUCCESS:
      return {
        ...state,
        isGettingDemoMonths: false,
        getDemoMonthsSuccess: true,
        demoMonths: action.payload,
        error: null,
      };
    case Actions.GET_DEMO_MONTHS_FAILURE:
      return {
        ...state,
        isGettingDemoMonths: false,
        getDemoMonthsSuccess: false,
        error: action.payload,
      };
  case Actions.GET_DEMO_DAYS_START:
    return {
      ...state,
      isGettingDemoDays: true,
      getDemoDaysSuccess: false,
      error: null,
    };
    case Actions.GET_DEMO_DAYS_SUCCESS:
      return {
        ...state,
        isGettingDemoDays: false,
        getDemoDaysSuccess: true,
        demoDays: action.payload,
        error: null,
      };
    case Actions.GET_DEMO_DAYS_FAILURE:
      return {
        ...state,
        isGettingDemoDays: false,
        getDemoDaysSuccess: false,
        error: action.payload,
      };
    case Actions.BOOK_SLOT_START:
      return {
        ...state,
        isBookingSlot: true,
        bookingSlotSuccess: false,
        error: null,
      };
    case Actions.BOOK_SLOT_SUCCESS:
      return {
        ...state,
        isBookingSlot: false,
        bookingSlotSuccess: true,
      };
    case Actions.BOOK_SLOT_FAILURE:
      return {
        ...state,
        isBookingSlot: false,
        bookingSlotSuccess: false,
        error: action.payload,
      };
    case Actions.CLEAR_DEMO_STATE:
      return initialState;
    default:
      return state;
  }
};
